(() => {
  const formatMoney = (cents, format) => {
    const money = Number(cents || 0) / 100;
    const template = format || '€{{amount}}';
    const token = template.match(/\{\{\s*(amount(?:_no_decimals|_with_comma_separator|_no_decimals_with_comma_separator|_with_apostrophe_separator)?)\s*\}\}/);
    if (!token) return money.toFixed(2);
    const noDecimals = token[1].includes('no_decimals');
    const commaDecimal = token[1].includes('comma_separator');
    const apostropheThousands = token[1].includes('apostrophe_separator');
    const decimals = noDecimals ? 0 : 2;
    const parts = money.toFixed(decimals).split('.');
    const thousands = apostropheThousands ? "'" : (commaDecimal ? '.' : ',');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    const value = decimals ? `${parts[0]}${commaDecimal ? ',' : '.'}${parts[1]}` : parts[0];
    return template.replace(token[0], value);
  };

  const closeMenu = (header) => {
    const button = header.querySelector('[data-itb-menu-button]');
    const panel = header.querySelector('[data-itb-menu]');
    if (!button || !panel) return;
    button.setAttribute('aria-expanded', 'false');
    button.setAttribute('aria-label', button.dataset.labelOpen || 'Open menu');
    panel.hidden = true;
    document.body.classList.remove('itb-menu-open');
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-itb-menu-button]');
    if (button) {
      const header = button.closest('[data-itb-header]');
      const panel = header && header.querySelector('[data-itb-menu]');
      if (!panel) return;
      const willOpen = button.getAttribute('aria-expanded') !== 'true';
      button.setAttribute('aria-expanded', String(willOpen));
      button.setAttribute('aria-label', willOpen ? (button.dataset.labelClose || 'Close menu') : (button.dataset.labelOpen || 'Open menu'));
      panel.hidden = !willOpen;
      document.body.classList.toggle('itb-menu-open', willOpen);
      return;
    }

    const openHeader = document.querySelector('[data-itb-menu-button][aria-expanded="true"]')?.closest('[data-itb-header]');
    if (openHeader && !openHeader.contains(event.target)) closeMenu(openHeader);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-itb-header]').forEach(closeMenu);
  });

  window.addEventListener('resize', () => {
    if (window.innerWidth < 990) return;
    document.querySelectorAll('[data-itb-header]').forEach(closeMenu);
  });

  document.addEventListener('change', (event) => {
    const select = event.target.closest('[data-itb-variant-select]');
    if (!select) return;
    const product = select.closest('[data-itb-product]');
    const option = select.options[select.selectedIndex];
    const available = option.dataset.available === 'true';
    const price = Number(option.dataset.price || 0);
    const comparePrice = Number(option.dataset.comparePrice || 0);
    const moneyFormat = product.dataset.currencyFormat;
    const priceNode = product.querySelector('[data-itb-price]');
    const compareNode = product.querySelector('[data-itb-compare-price]');
    const button = product.querySelector('[data-itb-add-to-cart]');
    if (priceNode) priceNode.textContent = formatMoney(price, moneyFormat);
    if (compareNode) {
      compareNode.hidden = comparePrice <= price;
      compareNode.textContent = comparePrice > price ? formatMoney(comparePrice, moneyFormat) : '';
    }
    if (button) {
      button.disabled = !available;
      button.querySelector('span').textContent = available ? button.dataset.labelAvailable : button.dataset.labelSoldOut;
    }
    const url = new URL(window.location.href);
    url.searchParams.set('variant', option.value);
    window.history.replaceState({}, '', url);
  });

  document.addEventListener('click', (event) => {
    const thumb = event.target.closest('[data-itb-gallery-thumb]');
    if (!thumb) return;
    const gallery = thumb.closest('[data-itb-gallery]');
    gallery.querySelectorAll('[data-itb-gallery-thumb]').forEach((item) => {
      const active = item === thumb;
      item.classList.toggle('is-active', active);
      item.setAttribute('aria-pressed', String(active));
    });
    gallery.querySelectorAll('[data-itb-media]').forEach((item) => {
      const active = item.dataset.itbMedia === thumb.dataset.itbGalleryThumb;
      item.hidden = !active;
      item.classList.toggle('is-active', active);
      if (!active) item.querySelectorAll('video').forEach((video) => video.pause());
    });
  });

  document.querySelectorAll('[data-itb-recommendations]').forEach(async (container) => {
    if (!container.dataset.url || container.querySelector('[data-itb-recommendations-content]')) return;
    try {
      const response = await fetch(container.dataset.url, { headers: { Accept: 'text/html' } });
      if (!response.ok) return;
      const documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
      const content = documentFragment.querySelector('[data-itb-recommendations-content]');
      if (content) container.replaceChildren(content);
    } catch (_) {
      /* Recommendations are optional; preserve the product page if unavailable. */
    }
  });
})();
